var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/region', 'app-common/util/cache-manager'], function($, core, RegionCollection, cacheManager) {
  var CachedRegionCollection;
  CachedRegionCollection = (function(_super) {

    __extends(CachedRegionCollection, _super);

    function CachedRegionCollection() {
      CachedRegionCollection.__super__.constructor.apply(this, arguments);
    }

    CachedRegionCollection.prototype.initialize = function(models, options) {
      CachedRegionCollection.__super__.initialize.call(this, models, options);
      return cacheManager.wrapFetch(this, 'region');
    };

    return CachedRegionCollection;

  })(RegionCollection);
  return CachedRegionCollection;
});
